<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'QACenter', to: { path: '/res-qa' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>[Warranty/FAQ/RMA]項目</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toQACreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增項目</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <QACenterTable></QACenterTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACenterTable from '@/views/G-3__QACategory/c/QACenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    QACenterTable,
  },
  created() {
    this.clear();
    this.getQAList();
  },
  methods: {
    ...mapActions('resqa', {
      getQAList: 'find',
      clear: 'clear',
    }),
    toQACreate() {
      this.$router.push('/res-qa/create');
    },
  },
};
</script>

<style></style>
